import ReactDOM from 'react-dom/client'
import './index.scss'
import Modal from 'react-modal'
import reportWebVitals from './reportWebVitals'
import 'react-toastify/dist/ReactToastify.css' // We need this, or toasts won't show.
import * as Sentry from '@sentry/react'
import config from './config/config'
import App from './app'

Sentry.init({
  dsn: 'https://cb29261b08ebea72c9f6bb6ca1f3a834@o4507579844263936.ingest.us.sentry.io/4507580355444736',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: true
    }),
    Sentry.replayCanvasIntegration()
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/university\.dopa\.ge\/api/, /^https:\/\/api\.dopa\.ge\/api\//, /^https:\/\/cognito-idp\.[a-z]{2}-[a-z]+-\d\.amazonaws\.com/],
  // Session Replay
  replaysSessionSampleRate: 1.0, // Capture 100% of all sessions for replay
  replaysOnErrorSampleRate: 1.0, // Capture 100% of all sessions when an error occurs
  environment: config.environment
})

Modal.setAppElement('#root')
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <App />
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
